export enum InsuranceCompany {
  AARP = "AARP",
  AETNA = "Aetna",
  AETNA_BETTER_HEALTH = "Aetna Better Health",
  AETNA_MEDICAID = "Aetna Medicaid",
  AETNA_MEDICARE = "Aetna Medicare",
  AETNA_SIGNATURE_ADMINISTRATORS = "Aetna Signature Administrators",
  AETNA_STUDENT_HEALTH = "Aetna Student Health",
  ALL_SAVERS_INSURANCE = "All Savers Insurance",
  ALLIANCE_HEALTH_PLAN = "Alliance Health Plan",
  ALLWELL = "Allwell",
  ALTIUS_HEALTH_PLANS = "Altius Health Plans",
  AMBETTER = "Ambetter",
  AMERICHOICE = "AmeriChoice",
  AMERIGROUP = "Amerigroup",
  AMERIHEALTH = "AmeriHealth",
  AMERIHEALTH_CARITAS = "AmeriHealth Caritas",
  AMERIHEALTH_CARITAS_NEW_HAMPSHIRE = "AmeriHealth Caritas New Hampshire",
  AMERIHEALTH_CARITAS_PENNSYLVANIA = "AmeriHealth Caritas Pennsylvania",
  AMERIHEALTH_CARITAS_DISTRICT_OF_COLUMBIA = "AmeriHealth Caritas District of Columbia",
  AMERIHEALTH_CARITAS_LOUISIANA = "AmeriHealth Caritas Louisiana",
  AMERIHEALTH_CARITAS_NORTH_CAROLINA = "AmeriHealth Caritas North Carolina",
  ANTHEM_BLUE_CROSS = "Anthem Blue Cross",
  ANTHEM_BLUE_CROSS_BLUE_SHIELD = "Anthem Blue Cross Blue Shield",
  ANTHEM_BLUE_CROSS_BLUE_SHIELD_COLORADO = "Anthem Blue Cross Blue Shield Colorado",
  ANTHEM_BLUE_CROSS_BLUE_SHIELD_CONNECTICUT = "Anthem Blue Cross Blue Shield Connecticut",
  ANTHEM_BLUE_CROSS_BLUE_SHIELD_INDIANA = "Anthem Blue Cross Blue Shield Indiana",
  ANTHEM_BLUE_CROSS_BLUE_SHIELD_KENTUCKY = "Anthem Blue Cross Blue Shield Kentucky",
  ANTHEM_BLUE_CROSS_BLUE_SHIELD_MAINE = "Anthem Blue Cross Blue Shield Maine",
  ANTHEM_BLUE_CROSS_BLUE_SHIELD_MISSOURI = "Anthem Blue Cross Blue Shield Missouri",
  ANTHEM_BLUE_CROSS_BLUE_SHIELD_NEVADA = "Anthem Blue Cross Blue Shield Nevada",
  ANTHEM_BLUE_CROSS_BLUE_SHIELD_NEW_HAMPSHIRE = "Anthem Blue Cross Blue Shield New Hampshire",
  ANTHEM_BLUE_CROSS_BLUE_SHIELD_OHIO = "Anthem Blue Cross Blue Shield Ohio",
  ANTHEM_BLUE_CROSS_BLUE_SHIELD_VIRGINIA = "Anthem Blue Cross Blue Shield Virginia",
  ANTHEM_BLUE_CROSS_BLUE_SHIELD_WISCONSIN = "Anthem Blue Cross Blue Shield Wisconsin",
  ANTHEM_MEDICAID = "Anthem Medicaid",
  ANTHEM_MEDICARE = "Anthem Medicare",
  ANTHEM_STUDENT_ADVANTAGE = "Anthem Student Advantage",
  ANTHEM_WHOLE_HEALTH_CONNECTION = "Anthem Whole Health Connection",
  ARKANSAS_BLUE_CROSS_BLUE_SHIELD = "Arkansas Blue Cross Blue Shield",
  ASURIS_NORTHWEST_HEALTH = "Asuris Northwest Health",
  BCBST_MEDICARE_ADVANTAGE = "BCBST Medicare Advantage",
  BCN_ADVANTAGE = "BCN Advantage",
  BLUE_ADVANTAGE_AL = "Blue Advantage (AL)",
  BLUE_ADVANTAGE_NC = "Blue Advantage (NC)",
  BLUE_CARE_NETWORK = "Blue Care Network",
  BLUE_CROSS_AND_BLUE_SHIELD_COMMUNITY_HEALTH_PLANS = "Blue Cross & Blue Shield Community Health Plans",
  BLUE_CROSS_AND_BLUE_SHIELD_OF_KANSAS_CITY = "Blue Cross & Blue Shield of Kansas City",
  BLUE_CROSS_BLUE_SHIELD_OF_ALABAMA = "Blue Cross Blue Shield of Alabama",
  BLUE_CROSS_BLUE_SHIELD_OF_ARIZONA = "Blue Cross Blue Shield of Arizona",
  BLUE_CROSS_BLUE_SHIELD_FEDERAL_EMPLOYEE_PROGRAM = "Blue Cross Blue Shield Federal Employee Program",
  FEDERAL_EMPLOYEE_FEP_BCBS = "Federal Employee (FEP) BCBS",
  BLUE_CROSS_BLUE_SHIELD_OF_GEORGIA = "Blue Cross Blue Shield of Georgia",
  BLUE_CROSS_BLUE_SHIELD_OF_HAWAII = "Blue Cross Blue Shield of Hawaii",
  BLUE_CROSS_BLUE_SHIELD_OF_ILLINOIS = "Blue Cross Blue Shield of Illinois",
  BLUE_CROSS_BLUE_SHIELD_OF_KANSAS = "Blue Cross Blue Shield of Kansas",
  BLUE_CROSS_BLUE_SHIELD_OF_KANSAS_CITY = "Blue Cross Blue Shield of Kansas City",
  BLUE_CROSS_BLUE_SHIELD_OF_LOUISIANA = "Blue Cross Blue Shield of Louisiana",
  BLUE_CROSS_BLUE_SHIELD_OF_MARYLAND = "Blue Cross Blue Shield of Maryland",
  BLUE_CROSS_BLUE_SHIELD_OF_MASSACHUSETTS = "Blue Cross Blue Shield of Massachusetts",
  BLUE_CROSS_BLUE_SHIELD_OF_MICHIGAN = "Blue Cross Blue Shield of Michigan",
  BLUE_CROSS_BLUE_SHIELD_OF_MINNESOTA = "Blue Cross Blue Shield of Minnesota",
  BLUE_CROSS_BLUE_SHIELD_OF_MONTANA = "Blue Cross Blue Shield of Montana",
  BLUE_CROSS_BLUE_SHIELD_OF_NEBRASKA = "Blue Cross Blue Shield of Nebraska",
  BLUE_CROSS_BLUE_SHIELD_OF_NEW_MEXICO = "Blue Cross Blue Shield of New Mexico",
  BLUE_CROSS_BLUE_SHIELD_OF_NORTH_CAROLINA = "Blue Cross Blue Shield of North Carolina",
  BLUE_CROSS_BLUE_SHIELD_OF_NORTH_DAKOTA = "Blue Cross Blue Shield of North Dakota",
  BLUE_CROSS_BLUE_SHIELD_OF_OKLAHOMA = "Blue Cross Blue Shield of Oklahoma",
  BLUE_CROSS_BLUE_SHIELD_OF_PUERTO_RICO = "Blue Cross Blue Shield of Puerto Rico",
  BLUE_CROSS_BLUE_SHIELD_OF_RHODE_ISLAND = "Blue Cross Blue Shield of Rhode Island",
  BLUE_CROSS_BLUE_SHIELD_OF_SOUTH_CAROLINA = "Blue Cross Blue Shield of South Carolina",
  BLUE_CROSS_BLUE_SHIELD_OF_TENNESSEE = "Blue Cross Blue Shield of Tennessee",
  BLUE_CROSS_BLUE_SHIELD_OF_TEXAS = "Blue Cross Blue Shield of Texas",
  BLUE_CROSS_BLUE_SHIELD_OF_VERMONT = "Blue Cross Blue Shield of Vermont",
  BLUE_CROSS_BLUE_SHIELD_OF_WYOMING = "Blue Cross Blue Shield of Wyoming",
  BLUE_CROSS_COMPLETE_OF_MICHIGAN = "Blue Cross Complete of Michigan",
  BLUE_CROSS_OF_IDAHO = "Blue Cross of Idaho",
  BLUE_HOME = "Blue Home",
  BLUE_HSA = "Blue HSA",
  BLUE_KC = "Blue KC",
  BLUE_MEDICARE = "Blue Medicare",
  BLUE_SELECT_AL = "Blue Select (AL)",
  BLUE_SELECT_NC = "Blue Select (NC)",
  BLUE_SHIELD_OF_CALIFORNIA = "Blue Shield of California",
  BLUE_SHIELD_PROMISE_HEALTH_PLAN = "Blue Shield Promise Health Plan",
  BLUE_VALUE = "Blue Value",
  BLUECARE_TENNESSEE = "BlueCare Tennessee",
  BLUECROSS_BLUESHIELD_OF_TENNESSEE = "BlueCross BlueShield of Tennessee",
  BLUERE_OF_TENNESSEE = "BlueRe of Tennessee",
  BRIDGESPAN_HEALTH = "BridgeSpan Health",
  BRIGHT_HEALTH_MEDICARE_ADVANTAGE = "Bright Health Medicare Advantage",
  BRIGHT_HEALTHCARE = "Bright HealthCare",
  BUCKEYE_HEALTH_PLAN = "Buckeye Health Plan",
  C_PLUS = "C Plus",
  CAMBIA_HEALTH_SOLUTIONS = "Cambia Health Solutions",
  CAPITAL_BLUE_CROSS = "Capital Blue Cross",
  CAREFIRST = "CareFirst",
  CAREFIRST_ADMINISTRATORS = "CareFirst Administrators",
  CAREFIRST_BLUECHOICE = "CareFirst BlueChoice",
  CAREFIRST_BLUECROSS_BLUESHIELD = "CareFirst BlueCross BlueShield",
  CAREFIRST_COMMUNITY_HEALTH_PLAN_DISTRICT_OF_COLUMBIA = "CareFirst Community Health Plan District of Columbia",
  CAREMORE_HEALTH = "CareMore Health",
  CAREPLUS_HEALTH_PLANS = "CarePlus Health Plans",
  CENPATICO = "Cenpatico",
  CENTENE = "Centene",
  CIGNA = "Cigna",
  CIGNA_GROUP_INSURANCE = "Cigna group Insurance",
  CIGNA_HEALTH = "Cigna Health",
  CONVIVA = "Conviva",
  COVENTRY_HEALTH_CARE = "Coventry Health Care",
  DEAN_HEALTH_PLAN = "Dean Health Plan",
  DEARBORN_GROUP = "Dearborn Group",
  EASY_CHOICE_HEALTH_PLAN = "Easy Choice Health Plan",
  ECHO_HEALTH_VENTURES = "Echo Health Ventures",
  EMPIRE_BLUECROSS_BLUESHIELD = "Empire BlueCross BlueShield",
  ENVOLVE_HEALTH = "Envolve Health",
  ESSENCE_HEALTHCARE = "Essence Healthcare",
  EVERCARE = "Evercare",
  EXCELLUS_BLUECROSS_BLUESHIELD = "Excellus BlueCross BlueShield",
  FIDELIS_CARE = "Fidelis Care",
  FIRST_CHOICE = "First Choice",
  FIRST_HEALTH = "First Health",
  FLORIDA_BLUE = "Florida Blue",
  FLORIDA_BLUE_HMO = "Florida Blue HMO",
  FLORIDA_BLUE_MEDICARE = "Florida Blue Medicare",
  FREEDOM_HEALTH = "Freedom Health",
  GO365 = "Go365",
  GOLDEN_RULE_INSURANCE_COMPANY = "Golden Rule Insurance Company",
  GREAT_WEST_HEALTHCARE = "Great-West Healthcare",
  GUIDEWELL = "GuideWell",
  HARMONY_HEALTH_PLANS = "Harmony Health Plans",
  HARVARD_PILGRIM = "Harvard Pilgrim",
  HEALTH_NET = "Health Net",
  HEALTH_NET_FEDERAL_SERVICES = "Health Net Federal Services",
  HEALTH_OPTIONS = "Health Options",
  HEALTHLINK = "HealthLink",
  HEALTHSPRING = "HealthSpring",
  HEALTHY_BLUE_BCBS = "Healthy Blue (BCBS)",
  HEALTHY_BLUE_ANTHEM = "Healthy Blue (Anthem)",
  HIGHMARK = "Highmark",
  HIGHMARK_BLUE_CROSS_BLUE_SHIELD = "Highmark Blue Cross Blue Shield",
  HIGHMARK_BLUE_CROSS_BLUE_SHIELD_DELAWARE = "Highmark Blue Cross Blue Shield Delaware",
  HIGHMARK_BLUE_CROSS_BLUE_SHIELD_NEW_YORK = "Highmark Blue Cross Blue Shield New York",
  HIGHMARK_BLUE_CROSS_BLUE_SHIELD_OF_WESTERN_NEW_YORK = "Highmark Blue Cross Blue Shield of Western New York",
  HIGHMARK_BLUE_CROSS_BLUE_SHIELD_WEST_VIRGINA = "Highmark Blue Cross Blue Shield West Virgina",
  HIGHMARK_BLUE_SHIELD_OF_NORTHERN_NEW_YORK = "Highmark Blue Shield of Northern New York",
  HIGHMARK_BLUE_SHIELD_PENNSYLVANIA = "Highmark Blue Shield Pennsylvania",
  HIGHMARK_HEALTH_OPTIONS = "Highmark Health Options",
  HIGHMARK_WHOLECARE = "Highmark Wholecare",
  HORIZON_BLUE_CROSS_BLUE_SHIELD_OF_NEW_JERSEY = "Horizon Blue Cross Blue Shield of New Jersey",
  HORIZON_MEDICARE_BLUE = "Horizon Medicare Blue",
  HORIZON_NJ_HEALTH = "Horizon NJ Health",
  HUMANA = "Humana",
  HUMANA_HEALTH_BENEFIT_PLAN_OF_LOUISIANA = "Humana Health Benefit Plan of Louisiana",
  HUMANA_HEALTHY_HORIZONS = "Humana Healthy Horizons",
  HUMANA_MEDICAID = "Humana Medicaid",
  HUMANA_MILITARY = "Humana Military",
  HUMANAONE = "HumanaOne",
  INDEPENDENCE_ADMINISTRATORS = "Independence Administrators",
  INDEPENDENCE_BCBS = "Independence BCBS",
  INDEPENDENCE_BLUE_CROSS = "Independence Blue Cross",
  INNOVATION_HEALTH = "Innovation Health",
  KAISER = "Kaiser",
  KAISER_PERMANENTE = "Kaiser Permanente",
  KEYSTONE_HEALTH_PLAN_EAST = "Keystone Health Plan East",
  KEYSTONE_FIRST = "Keystone First",
  KINDRED_AT_HOME = "Kindred at Home",
  LA_CARE = "L.A. Care",
  LIFEMAP = "LifeMap",
  LIFEWISE_HEALTH_PLAN = "LifeWise Health Plan",
  LUMERIS = "Lumeris",
  MAGNOLIA_HEALTH = "Magnolia Health",
  MANAGED_HEALTH_SERVICES = "Managed Health Services",
  MARYLAND_CAREFIRST_BLUECROSS_BLUESHIELD = "Maryland CareFirst BlueCross BlueShield",
  MEDICA_ADVANTAGE_PLAN = "Medica Advantage Plan",
  MEDICA_CHOICE = "Medica Choice",
  MEDICA_HEALTH_PLANS = "Medica Health Plans",
  MEDICA_HEALTHCARE_PLANS = "Medica HealthCare Plans",
  MERITAIN_HEALTH = "Meritain Health",
  MOLINA_COMPLETE_CARE = "Molina Complete Care",
  MOLINA_DUAL_OPTIONS = "Molina Dual Options",
  MOLINA_HEALTH_INSURANCE = "Molina Health Insurance",
  MOLINA_HEALTHCARE = "Molina Healthcare",
  MOLINA_HEALTHCARE_OF_PUERTO_RICO = "Molina Healthcare of Puerto Rico",
  MOLINA_HEALTHCARE_OF_WISCONSIN = "Molina Healthcare of Wisconsin",
  MOLINA_MARKETPLACE = "Molina Marketplace",
  MOLINA_MEDICAID = "Molina Medicaid",
  MOLINA_MEDICARE = "Molina Medicare",
  MOLINA_MYCHOICE = "Molina MyChoice",
  OHANA_HEALTH_PLAN = "Ohana Health Plan",
  OPTIMED = "OptiMed",
  OPTIMED_HEALTH = "Optimed Health",
  OPTIMUM_HEALTHCARE = "Optimum HealthCare",
  OSCAR_HEALTH_PLAN = "Oscar Health Plan",
  OSCAR_MEDICARE_ADVANTAGE = "Oscar Medicare Advantage",
  OXFORD_HEALTH_PLANS = "Oxford Health Plans",
  PACIFICARE = "PacifiCare",
  PASSPORT_HEALTH_PLAN = "Passport Health Plan",
  PEACH_STATE_HEALTH_PLAN = "Peach State Health Plan",
  PERFORMCARE = "PerformCare",
  PREMERA = "Premera",
  PREMERA_BLUE_CROSS = "Premera Blue Cross",
  PREMERA_BLUE_CROSS_BLUE_SHIELD_OF_ALASKA = "Premera Blue Cross Blue Shield of Alaska",
  PREMERA_BLUE_CROSS_BLUE_SHIELD_OF_WASHINGTON = "Premera Blue Cross Blue Shield of Washington",
  PRIORITY_HEALTH_OF_MICHIGAN = "Priority Health of Michigan",
  QCC_INSURANCE_COMPANY = "QCC Insurance Company",
  REGENCE_BLUECROSS_BLUESHIELD = "Regence BlueCross BlueShield",
  REGENCE_BLUECROSS_BLUESHIELD_OF_OREGON = "Regence BlueCross BlueShield of Oregon",
  REGENCE_BLUECROSS_BLUESHIELD_OF_UTAH = "Regence BlueCross BlueShield of Utah",
  REGENCE_BLUECROSS_OF_IDAHO = "Regence BlueCross of Idaho",
  REGENCE_BLUESHIELD = "Regence BlueShield",
  SELECT_HEALTH_OF_SOUTH_CAROLINA = "Select Health of South Carolina",
  SIERRA_HEALTH_AND_LIFE = "Sierra Health and Life",
  SIMPLY_HEALTHCARE = "Simply Healthcare",
  STAYWELL_HEALTH_PLAN = "Staywell Health Plan",
  SUNSHINE_HEALTH = "Sunshine Health",
  SUPERIOR_HEALTHPLAN = "Superior HealthPlan",
  SUREST = "Surest",
  TOTAL_HEALTH_CARE = "Total Health Care",
  TRANSCEND = "Transcend",
  TRICARE = "Tricare",
  TRILLIUM_COMMUNITY_HEALTH_PLAN = "Trillium Community Health Plan",
  TUFTS_HEALTH_PLAN = "Tufts Health Plan",
  UMR = "UMR",
  UNICARE = "UniCare",
  UNITED_CONCORDIA_DENTAL = "United Concordia Dental",
  UNITED_HEALTHCARE = "United Healthcare",
  UNITED_HEALTHCARE_WEST = "United Healthcare West",
  UNITEDHEALTHCARE = "UnitedHealthcare",
  UNITEDHEALTHCARE_COMMUNITY_AND_STATE = "UnitedHealthcare Community & State",
  UNITEDHEALTHCARE_GLOBAL = "UnitedHealthcare Global",
  UNITEDHEALTHCARE_MEDICARE_AND_RETIREMENT = "UnitedHealthcare Medicare & Retirement",
  UNITEDHEALTHCARE_NETWORKS_AND_ADMINISTRATIVE_SERVICES = "UnitedHealthcare Networks & Administrative Services",
  UNITEDHEALTHCARE_OXFORD = "UnitedHealthcare Oxford",
  UNITEDHEALTHCARE_PLAN_OF_THE_RIVER_VALLEY = "UnitedHealthcare Plan of the River Valley",
  UNITEDHEALTHCARE_STUDENTRESOURCES = "UnitedHealthcare StudentResources",
  UNITEDHEALTHCARE_ALL_SAVERS = "UnitedHealthcare All Savers",
  UPMC_COMMUNITY_HEALTHCHOICES = "UPMC Community HealthChoices",
  UPMC_HEALTH_PLAN = "UPMC Health Plan",
  UPMC_WORKPARTNERS = "UPMC WorkPartners",
  VETERANS_HEALTH_ADMINISTRATION = "Veterans Health Administration",
  WELLCARE = "WellCare",
  WELLCARE_HEALTH_PLANS = "WellCare Health Plans",
  WELLMARK_BLUE_CROSS_BLUE_SHIELD_OF_IOWA = "Wellmark Blue Cross Blue Shield of Iowa",
  WELLMARK_BLUE_CROSS_BLUE_SHIELD_OF_SOUTH_DAKOTA = "Wellmark Blue Cross Blue Shield of South Dakota",
  WELLPOINT = "Wellpoint",
  DEVOTED_HEALTH = "Devoted Health",
}

export enum PBM {
  CAPITALRX = "CapitalRx",
  CARELONRX = "CarelonRx",
  CVS_CAREMARK = "CVS Caremark",
  ELIXIR = "Elixir",
  ENVOLVE_PHARMACY_SOLUTIONS = "Envolve Pharmacy Solutions",
  EXPRESS_SCRIPTS = "Express Scripts",
  HUMANA_PHARMACY_SOLUTIONS = "Humana Pharmacy Solutions",
  KAISER_PERMANENTE = "Kaiser Permanente",
  MAGELLAN_RX = "Magellan Rx",
  MAGELLAN_RX_MANAGEMENT = "Magellan Rx Management",
  MEDIMPACT = "MedImpact",
  NAVITUS_HEALTH_SOLUTIONS = "Navitus Health Solutions",
  OPTUMRX = "OptumRX",
  PERFORMRX = "PerformRx",
  PRIME_THERAPEUTICS = "Prime Therapeutics",
  RIGHTWAY = "Rightway",
  RXADVANCE = "RxAdvance",
  WELLDYNERX = "WellDyneRx",
}

export enum CcDestinationParent {
  UNITEDHEALTHCARE = "UnitedHealthcare",
  CENTENE = "Centene",
  CIGNA = "Cigna",
  AETNA = "Aetna",
  AMERISOURCE_BERGEN = "Amerisource Bergen",
  ELEVANCE_HEALTH = "Elevance Health",
  INDEPENDENCE_BCBS = "Independence BCBS",
  BCBS_ARKANSAS = "BCBS Arkansas",
  CAMBIA_HEALTH_SOLUTIONS = "Cambia Health Solutions",
  BCBS_TENNESSEE = "BCBS Tennessee",
  BCBS_MICHIGAN = "BCBS Michigan",
  BCBS_ALABAMA = "BCBS Alabama",
  BCBS_NORTH_CAROLINA = "BCBS North Carolina",
  BLUE_KC = "Blue KC",
  BCBS_ARIZONA = "BCBS Arizona",
  BCBS_FEDERAL_EMPLOYEE_PLAN = "BCBS Federal Employee Plan",
  BCBS_HAWAII = "BCBS Hawaii",
  HCSC = "HCSC",
  BCBS_KANSAS = "BCBS Kansas",
  BCBS_LOUISIANA = "BCBS Louisiana",
  CAREFIRST_BCBS = "CareFirst BCBS",
  BCBS_MASSACHUSETTS = "BCBS Massachusetts",
  BCBS_MINNESOTA = "BCBS Minnesota",
  BCBS_NEBRASKA = "BCBS Nebraska",
  BCBS_NORTH_DAKOTA = "BCBS North Dakota",
  BCBS_RHODE_ISLAND = "BCBS Rhode Island",
  BCBS_SOUTH_CAROLINA = "BCBS South Carolina",
  BCBS_VERMONT = "BCBS Vermont",
  BCBS_WYOMING = "BCBS Wyoming",
  BC_IDAHO = "BC Idaho",
  BLUE_SHIELD_OF_CALIFORNIA = "Blue Shield of California",
  BRIGHT_HEALTH = "Bright Health",
  CAPITAL_BLUE_CROSS = "Capital Blue Cross",
  HUMANA = "Humana",
  MEDICA = "Medica",
  LUMERIS = "Lumeris",
  LIFETIME_HEALTHCARE_COMPANIES = "Lifetime Healthcare Companies",
  POINT32HEALTH = "Point32Health",
  GUIDEWELL = "Guidewell",
  HIGHMARK = "Highmark",
  HORIZON_BCBS_NEW_JERSEY = "Horizon BCBS New Jersey",
  KAISER = "Kaiser",
  LA_CARE = "L.A. Care",
  PREMERA = "Premera",
  PRIME = "Prime",
  MEDIMPACT = "MedImpact",
  MOLINA_HEALTHCARE = "Molina Healthcare",
  OPTIMED = "OptiMed",
  OSCAR_HEALTH = "Oscar Health",
  PRIORITY_HEALTH = "Priority Health",
  UPMC = "UPMC",
  DEPARTMENT_OF_VETERANS_AFFAIRS = "Department of Veterans Affairs",
  WELLMARK = "Wellmark",
  DEVOTED_HEALTH = "Devoted Health",
}

export enum ClinicalCriteriaParent {
  UNITEDHEALTHCARE = "UnitedHealthcare",
  ANTHEM = "Anthem",
  CIGNA = "Cigna",
  AETNA = "Aetna",
  BCBS = "BCBS",
  BCBS_FEP = "BCBS FEP",
  HIGHMARK = "Highmark",
  WELLMARK = "Wellmark",
}

export type OrgParents = {
  ccDestinationParent?: CcDestinationParent;
  clinicalCriteriaParent?: ClinicalCriteriaParent;
};

export const denyingPartyToParentMap: Record<string, OrgParents> = {
  [InsuranceCompany.AARP]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.AETNA]: {
    ccDestinationParent: CcDestinationParent.AETNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.AETNA,
  },
  [InsuranceCompany.AETNA_BETTER_HEALTH]: {
    ccDestinationParent: CcDestinationParent.AETNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.AETNA,
  },
  [InsuranceCompany.AETNA_MEDICAID]: {
    ccDestinationParent: CcDestinationParent.AETNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.AETNA,
  },
  [InsuranceCompany.AETNA_MEDICARE]: {
    ccDestinationParent: CcDestinationParent.AETNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.AETNA,
  },
  [InsuranceCompany.AETNA_SIGNATURE_ADMINISTRATORS]: {
    ccDestinationParent: CcDestinationParent.AETNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.AETNA,
  },
  [InsuranceCompany.AETNA_STUDENT_HEALTH]: {
    ccDestinationParent: CcDestinationParent.AETNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.AETNA,
  },
  [InsuranceCompany.ALL_SAVERS_INSURANCE]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.ALLIANCE_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.AMERISOURCE_BERGEN,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ALLWELL]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ALTIUS_HEALTH_PLANS]: {
    ccDestinationParent: CcDestinationParent.AETNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.AETNA,
  },
  [InsuranceCompany.AMBETTER]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.AMERICHOICE]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.AMERIGROUP]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.AMERIHEALTH]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.AMERIHEALTH_CARITAS]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.AMERIHEALTH_CARITAS_NEW_HAMPSHIRE]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.AMERIHEALTH_CARITAS_PENNSYLVANIA]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.AMERIHEALTH_CARITAS_DISTRICT_OF_COLUMBIA]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.AMERIHEALTH_CARITAS_LOUISIANA]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.AMERIHEALTH_CARITAS_NORTH_CAROLINA]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS_BLUE_SHIELD]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS_BLUE_SHIELD_COLORADO]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS_BLUE_SHIELD_CONNECTICUT]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS_BLUE_SHIELD_INDIANA]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS_BLUE_SHIELD_KENTUCKY]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS_BLUE_SHIELD_MAINE]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS_BLUE_SHIELD_MISSOURI]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS_BLUE_SHIELD_NEVADA]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS_BLUE_SHIELD_NEW_HAMPSHIRE]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS_BLUE_SHIELD_OHIO]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS_BLUE_SHIELD_VIRGINIA]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_BLUE_CROSS_BLUE_SHIELD_WISCONSIN]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_MEDICAID]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_MEDICARE]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_STUDENT_ADVANTAGE]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ANTHEM_WHOLE_HEALTH_CONNECTION]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ARKANSAS_BLUE_CROSS_BLUE_SHIELD]: {
    ccDestinationParent: CcDestinationParent.BCBS_ARKANSAS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.ASURIS_NORTHWEST_HEALTH]: {
    ccDestinationParent: CcDestinationParent.CAMBIA_HEALTH_SOLUTIONS,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.BCBST_MEDICARE_ADVANTAGE]: {
    ccDestinationParent: CcDestinationParent.BCBS_TENNESSEE,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BCN_ADVANTAGE]: {
    ccDestinationParent: CcDestinationParent.BCBS_MICHIGAN,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_ADVANTAGE_AL]: {
    ccDestinationParent: CcDestinationParent.BCBS_ALABAMA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_ADVANTAGE_NC]: {
    ccDestinationParent: CcDestinationParent.BCBS_NORTH_CAROLINA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CARE_NETWORK]: {
    ccDestinationParent: CcDestinationParent.BCBS_MICHIGAN,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_AND_BLUE_SHIELD_COMMUNITY_HEALTH_PLANS]: {
    ccDestinationParent: CcDestinationParent.BLUE_KC,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_AND_BLUE_SHIELD_OF_KANSAS_CITY]: {
    ccDestinationParent: CcDestinationParent.BLUE_KC,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_ALABAMA]: {
    ccDestinationParent: CcDestinationParent.BCBS_ALABAMA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_ARIZONA]: {
    ccDestinationParent: CcDestinationParent.BCBS_ARIZONA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_FEDERAL_EMPLOYEE_PROGRAM]: {
    ccDestinationParent: CcDestinationParent.BCBS_FEDERAL_EMPLOYEE_PLAN,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.FEDERAL_EMPLOYEE_FEP_BCBS]: {
    ccDestinationParent: CcDestinationParent.BCBS_FEDERAL_EMPLOYEE_PLAN,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_GEORGIA]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_HAWAII]: {
    ccDestinationParent: CcDestinationParent.BCBS_HAWAII,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_ILLINOIS]: {
    ccDestinationParent: CcDestinationParent.HCSC,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_KANSAS]: {
    ccDestinationParent: CcDestinationParent.BCBS_KANSAS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_KANSAS_CITY]: {
    ccDestinationParent: CcDestinationParent.BLUE_KC,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_LOUISIANA]: {
    ccDestinationParent: CcDestinationParent.BCBS_LOUISIANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_MARYLAND]: {
    ccDestinationParent: CcDestinationParent.CAREFIRST_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_MASSACHUSETTS]: {
    ccDestinationParent: CcDestinationParent.BCBS_MASSACHUSETTS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_MICHIGAN]: {
    ccDestinationParent: CcDestinationParent.BCBS_MICHIGAN,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_MINNESOTA]: {
    ccDestinationParent: CcDestinationParent.BCBS_MINNESOTA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_MONTANA]: {
    ccDestinationParent: CcDestinationParent.HCSC,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_NEBRASKA]: {
    ccDestinationParent: CcDestinationParent.BCBS_NEBRASKA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_NEW_MEXICO]: {
    ccDestinationParent: CcDestinationParent.HCSC,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_NORTH_CAROLINA]: {
    ccDestinationParent: CcDestinationParent.BCBS_NORTH_CAROLINA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_NORTH_DAKOTA]: {
    ccDestinationParent: CcDestinationParent.BCBS_NORTH_DAKOTA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_OKLAHOMA]: {
    ccDestinationParent: CcDestinationParent.HCSC,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_PUERTO_RICO]: {
    ccDestinationParent: CcDestinationParent.GUIDEWELL,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_RHODE_ISLAND]: {
    ccDestinationParent: CcDestinationParent.BCBS_RHODE_ISLAND,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_SOUTH_CAROLINA]: {
    ccDestinationParent: CcDestinationParent.BCBS_SOUTH_CAROLINA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_TENNESSEE]: {
    ccDestinationParent: CcDestinationParent.BCBS_TENNESSEE,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_TEXAS]: {
    ccDestinationParent: CcDestinationParent.HCSC,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_VERMONT]: {
    ccDestinationParent: CcDestinationParent.BCBS_VERMONT,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_BLUE_SHIELD_OF_WYOMING]: {
    ccDestinationParent: CcDestinationParent.BCBS_WYOMING,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_COMPLETE_OF_MICHIGAN]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_CROSS_OF_IDAHO]: {
    ccDestinationParent: CcDestinationParent.BC_IDAHO,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_HOME]: {
    ccDestinationParent: CcDestinationParent.BCBS_NORTH_CAROLINA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_HSA]: {
    ccDestinationParent: CcDestinationParent.BCBS_ALABAMA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_KC]: {
    ccDestinationParent: CcDestinationParent.BLUE_KC,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_MEDICARE]: {
    ccDestinationParent: CcDestinationParent.BCBS_NORTH_CAROLINA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_SELECT_AL]: {
    ccDestinationParent: CcDestinationParent.BCBS_ALABAMA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_SELECT_NC]: {
    ccDestinationParent: CcDestinationParent.BCBS_NORTH_CAROLINA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_SHIELD_OF_CALIFORNIA]: {
    ccDestinationParent: CcDestinationParent.BLUE_SHIELD_OF_CALIFORNIA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_SHIELD_PROMISE_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.BLUE_SHIELD_OF_CALIFORNIA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUE_VALUE]: {
    ccDestinationParent: CcDestinationParent.BCBS_NORTH_CAROLINA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUECARE_TENNESSEE]: {
    ccDestinationParent: CcDestinationParent.BCBS_TENNESSEE,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUECROSS_BLUESHIELD_OF_TENNESSEE]: {
    ccDestinationParent: CcDestinationParent.BCBS_TENNESSEE,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BLUERE_OF_TENNESSEE]: {
    ccDestinationParent: CcDestinationParent.BCBS_TENNESSEE,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.BRIDGESPAN_HEALTH]: {
    ccDestinationParent: CcDestinationParent.CAMBIA_HEALTH_SOLUTIONS,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.BRIGHT_HEALTH_MEDICARE_ADVANTAGE]: {
    ccDestinationParent: CcDestinationParent.BRIGHT_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.BRIGHT_HEALTHCARE]: {
    ccDestinationParent: CcDestinationParent.BRIGHT_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.BUCKEYE_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.C_PLUS]: {
    ccDestinationParent: CcDestinationParent.BCBS_ALABAMA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.CAMBIA_HEALTH_SOLUTIONS]: {
    ccDestinationParent: CcDestinationParent.CAMBIA_HEALTH_SOLUTIONS,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.CAPITAL_BLUE_CROSS]: {
    ccDestinationParent: CcDestinationParent.CAPITAL_BLUE_CROSS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.CAREFIRST]: {
    ccDestinationParent: CcDestinationParent.CAREFIRST_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.CAREFIRST_ADMINISTRATORS]: {
    ccDestinationParent: CcDestinationParent.CAREFIRST_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.CAREFIRST_BLUECHOICE]: {
    ccDestinationParent: CcDestinationParent.CAREFIRST_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.CAREFIRST_BLUECROSS_BLUESHIELD]: {
    ccDestinationParent: CcDestinationParent.CAREFIRST_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.CAREFIRST_COMMUNITY_HEALTH_PLAN_DISTRICT_OF_COLUMBIA]: {
    ccDestinationParent: CcDestinationParent.CAREFIRST_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.CAREMORE_HEALTH]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.CAREPLUS_HEALTH_PLANS]: {
    ccDestinationParent: CcDestinationParent.HUMANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.CENPATICO]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.CENTENE]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.CIGNA]: {
    ccDestinationParent: CcDestinationParent.CIGNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.CIGNA,
  },
  [InsuranceCompany.CIGNA_GROUP_INSURANCE]: {
    ccDestinationParent: CcDestinationParent.CIGNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.CIGNA,
  },
  [InsuranceCompany.CIGNA_HEALTH]: {
    ccDestinationParent: CcDestinationParent.CIGNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.CIGNA,
  },
  [InsuranceCompany.CONVIVA]: {
    ccDestinationParent: CcDestinationParent.HUMANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.COVENTRY_HEALTH_CARE]: {
    ccDestinationParent: CcDestinationParent.AETNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.AETNA,
  },
  [InsuranceCompany.DEAN_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.MEDICA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.DEARBORN_GROUP]: {
    ccDestinationParent: CcDestinationParent.HCSC,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.EASY_CHOICE_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ECHO_HEALTH_VENTURES]: {
    ccDestinationParent: CcDestinationParent.CAMBIA_HEALTH_SOLUTIONS,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.EMPIRE_BLUECROSS_BLUESHIELD]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ENVOLVE_HEALTH]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.ESSENCE_HEALTHCARE]: {
    ccDestinationParent: CcDestinationParent.LUMERIS,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.EVERCARE]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.EXCELLUS_BLUECROSS_BLUESHIELD]: {
    ccDestinationParent: CcDestinationParent.LIFETIME_HEALTHCARE_COMPANIES,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.FIDELIS_CARE]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.FIRST_CHOICE]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.FIRST_HEALTH]: {
    ccDestinationParent: CcDestinationParent.AETNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.AETNA,
  },
  [InsuranceCompany.FLORIDA_BLUE]: {
    ccDestinationParent: CcDestinationParent.GUIDEWELL,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.FLORIDA_BLUE_HMO]: {
    ccDestinationParent: CcDestinationParent.GUIDEWELL,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.FLORIDA_BLUE_MEDICARE]: {
    ccDestinationParent: CcDestinationParent.GUIDEWELL,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.FREEDOM_HEALTH]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.GO365]: {
    ccDestinationParent: CcDestinationParent.HUMANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.GOLDEN_RULE_INSURANCE_COMPANY]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.GREAT_WEST_HEALTHCARE]: {
    ccDestinationParent: CcDestinationParent.CIGNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.CIGNA,
  },
  [InsuranceCompany.GUIDEWELL]: {
    ccDestinationParent: CcDestinationParent.GUIDEWELL,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.HARMONY_HEALTH_PLANS]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.HARVARD_PILGRIM]: {
    ccDestinationParent: CcDestinationParent.POINT32HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.HEALTH_NET]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.HEALTH_NET_FEDERAL_SERVICES]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.HEALTH_OPTIONS]: {
    ccDestinationParent: CcDestinationParent.GUIDEWELL,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.HEALTHLINK]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.HEALTHSPRING]: {
    ccDestinationParent: CcDestinationParent.CIGNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.CIGNA,
  },
  [InsuranceCompany.HEALTHY_BLUE_BCBS]: {
    ccDestinationParent: CcDestinationParent.BCBS_NORTH_CAROLINA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.HEALTHY_BLUE_ANTHEM]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.HIGHMARK]: {
    ccDestinationParent: CcDestinationParent.HIGHMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.HIGHMARK,
  },
  [InsuranceCompany.HIGHMARK_BLUE_CROSS_BLUE_SHIELD]: {
    ccDestinationParent: CcDestinationParent.HIGHMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.HIGHMARK,
  },
  [InsuranceCompany.HIGHMARK_BLUE_CROSS_BLUE_SHIELD_DELAWARE]: {
    ccDestinationParent: CcDestinationParent.HIGHMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.HIGHMARK,
  },
  [InsuranceCompany.HIGHMARK_BLUE_CROSS_BLUE_SHIELD_NEW_YORK]: {
    ccDestinationParent: CcDestinationParent.HIGHMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.HIGHMARK,
  },
  [InsuranceCompany.HIGHMARK_BLUE_CROSS_BLUE_SHIELD_OF_WESTERN_NEW_YORK]: {
    ccDestinationParent: CcDestinationParent.HIGHMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.HIGHMARK,
  },
  [InsuranceCompany.HIGHMARK_BLUE_CROSS_BLUE_SHIELD_WEST_VIRGINA]: {
    ccDestinationParent: CcDestinationParent.HIGHMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.HIGHMARK,
  },
  [InsuranceCompany.HIGHMARK_BLUE_SHIELD_OF_NORTHERN_NEW_YORK]: {
    ccDestinationParent: CcDestinationParent.HIGHMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.HIGHMARK,
  },
  [InsuranceCompany.HIGHMARK_BLUE_SHIELD_PENNSYLVANIA]: {
    ccDestinationParent: CcDestinationParent.HIGHMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.HIGHMARK,
  },
  [InsuranceCompany.HIGHMARK_HEALTH_OPTIONS]: {
    ccDestinationParent: CcDestinationParent.HIGHMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.HIGHMARK,
  },
  [InsuranceCompany.HIGHMARK_WHOLECARE]: {
    ccDestinationParent: CcDestinationParent.HIGHMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.HIGHMARK,
  },
  [InsuranceCompany.HORIZON_BLUE_CROSS_BLUE_SHIELD_OF_NEW_JERSEY]: {
    ccDestinationParent: CcDestinationParent.HORIZON_BCBS_NEW_JERSEY,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.HORIZON_MEDICARE_BLUE]: {
    ccDestinationParent: CcDestinationParent.HORIZON_BCBS_NEW_JERSEY,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.HORIZON_NJ_HEALTH]: {
    ccDestinationParent: CcDestinationParent.HORIZON_BCBS_NEW_JERSEY,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.HUMANA]: {
    ccDestinationParent: CcDestinationParent.HUMANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.HUMANA_HEALTH_BENEFIT_PLAN_OF_LOUISIANA]: {
    ccDestinationParent: CcDestinationParent.HUMANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.HUMANA_HEALTHY_HORIZONS]: {
    ccDestinationParent: CcDestinationParent.HUMANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.HUMANA_MEDICAID]: {
    ccDestinationParent: CcDestinationParent.HUMANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.HUMANA_MILITARY]: {
    ccDestinationParent: CcDestinationParent.HUMANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.HUMANAONE]: {
    ccDestinationParent: CcDestinationParent.HUMANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.INDEPENDENCE_ADMINISTRATORS]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.INDEPENDENCE_BCBS]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.INDEPENDENCE_BLUE_CROSS]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.INNOVATION_HEALTH]: {
    ccDestinationParent: CcDestinationParent.AETNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.AETNA,
  },
  [InsuranceCompany.KAISER]: {
    ccDestinationParent: CcDestinationParent.KAISER,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.KAISER_PERMANENTE]: {
    ccDestinationParent: CcDestinationParent.KAISER,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.KEYSTONE_HEALTH_PLAN_EAST]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.KEYSTONE_FIRST]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.KINDRED_AT_HOME]: {
    ccDestinationParent: CcDestinationParent.HUMANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.LA_CARE]: {
    ccDestinationParent: CcDestinationParent.LA_CARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.LIFEMAP]: {
    ccDestinationParent: CcDestinationParent.CAMBIA_HEALTH_SOLUTIONS,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.LIFEWISE_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.PREMERA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.LUMERIS]: {
    ccDestinationParent: CcDestinationParent.LUMERIS,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MAGNOLIA_HEALTH]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MANAGED_HEALTH_SERVICES]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MARYLAND_CAREFIRST_BLUECROSS_BLUESHIELD]: {
    ccDestinationParent: CcDestinationParent.CAREFIRST_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.MEDICA_ADVANTAGE_PLAN]: {
    ccDestinationParent: CcDestinationParent.MEDICA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MEDICA_CHOICE]: {
    ccDestinationParent: CcDestinationParent.MEDICA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MEDICA_HEALTH_PLANS]: {
    ccDestinationParent: CcDestinationParent.MEDICA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MEDICA_HEALTHCARE_PLANS]: {
    ccDestinationParent: CcDestinationParent.MEDICA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MERITAIN_HEALTH]: {
    ccDestinationParent: CcDestinationParent.AETNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.AETNA,
  },
  [InsuranceCompany.MOLINA_COMPLETE_CARE]: {
    ccDestinationParent: CcDestinationParent.MOLINA_HEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MOLINA_DUAL_OPTIONS]: {
    ccDestinationParent: CcDestinationParent.MOLINA_HEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MOLINA_HEALTH_INSURANCE]: {
    ccDestinationParent: CcDestinationParent.MOLINA_HEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MOLINA_HEALTHCARE]: {
    ccDestinationParent: CcDestinationParent.MOLINA_HEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MOLINA_HEALTHCARE_OF_PUERTO_RICO]: {
    ccDestinationParent: CcDestinationParent.MOLINA_HEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MOLINA_HEALTHCARE_OF_WISCONSIN]: {
    ccDestinationParent: CcDestinationParent.MOLINA_HEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MOLINA_MARKETPLACE]: {
    ccDestinationParent: CcDestinationParent.MOLINA_HEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MOLINA_MEDICAID]: {
    ccDestinationParent: CcDestinationParent.MOLINA_HEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MOLINA_MEDICARE]: {
    ccDestinationParent: CcDestinationParent.MOLINA_HEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.MOLINA_MYCHOICE]: {
    ccDestinationParent: CcDestinationParent.MOLINA_HEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.OHANA_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.OPTIMED]: {
    ccDestinationParent: CcDestinationParent.OPTIMED,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.OPTIMED_HEALTH]: {
    ccDestinationParent: CcDestinationParent.OPTIMED,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.OPTIMUM_HEALTHCARE]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.OSCAR_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.OSCAR_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.OSCAR_MEDICARE_ADVANTAGE]: {
    ccDestinationParent: CcDestinationParent.OSCAR_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.OXFORD_HEALTH_PLANS]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.PACIFICARE]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.PASSPORT_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.MOLINA_HEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.PEACH_STATE_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.PERFORMCARE]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.PREMERA]: {
    ccDestinationParent: CcDestinationParent.PREMERA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.PREMERA_BLUE_CROSS]: {
    ccDestinationParent: CcDestinationParent.PREMERA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.PREMERA_BLUE_CROSS_BLUE_SHIELD_OF_ALASKA]: {
    ccDestinationParent: CcDestinationParent.PREMERA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.PREMERA_BLUE_CROSS_BLUE_SHIELD_OF_WASHINGTON]: {
    ccDestinationParent: CcDestinationParent.PREMERA,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.PRIORITY_HEALTH_OF_MICHIGAN]: {
    ccDestinationParent: CcDestinationParent.PRIORITY_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.QCC_INSURANCE_COMPANY]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.REGENCE_BLUECROSS_BLUESHIELD]: {
    ccDestinationParent: CcDestinationParent.CAMBIA_HEALTH_SOLUTIONS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.REGENCE_BLUECROSS_BLUESHIELD_OF_OREGON]: {
    ccDestinationParent: CcDestinationParent.CAMBIA_HEALTH_SOLUTIONS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.REGENCE_BLUECROSS_BLUESHIELD_OF_UTAH]: {
    ccDestinationParent: CcDestinationParent.CAMBIA_HEALTH_SOLUTIONS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.REGENCE_BLUECROSS_OF_IDAHO]: {
    ccDestinationParent: CcDestinationParent.CAMBIA_HEALTH_SOLUTIONS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.REGENCE_BLUESHIELD]: {
    ccDestinationParent: CcDestinationParent.CAMBIA_HEALTH_SOLUTIONS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.SELECT_HEALTH_OF_SOUTH_CAROLINA]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [InsuranceCompany.SIERRA_HEALTH_AND_LIFE]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.SIMPLY_HEALTHCARE]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.STAYWELL_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.SUNSHINE_HEALTH]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.SUPERIOR_HEALTHPLAN]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.SUREST]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.TOTAL_HEALTH_CARE]: {
    ccDestinationParent: CcDestinationParent.PRIORITY_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.TRANSCEND]: {
    ccDestinationParent: CcDestinationParent.HUMANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.TRICARE]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.TRILLIUM_COMMUNITY_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.TUFTS_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.POINT32HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.UMR]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.UNICARE]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.UNITED_CONCORDIA_DENTAL]: {
    ccDestinationParent: CcDestinationParent.HIGHMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.HIGHMARK,
  },
  [InsuranceCompany.UNITED_HEALTHCARE]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.UNITED_HEALTHCARE_WEST]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.UNITEDHEALTHCARE]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.UNITEDHEALTHCARE_COMMUNITY_AND_STATE]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.UNITEDHEALTHCARE_GLOBAL]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.UNITEDHEALTHCARE_MEDICARE_AND_RETIREMENT]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.UNITEDHEALTHCARE_NETWORKS_AND_ADMINISTRATIVE_SERVICES]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.UNITEDHEALTHCARE_OXFORD]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.UNITEDHEALTHCARE_PLAN_OF_THE_RIVER_VALLEY]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.UNITEDHEALTHCARE_STUDENTRESOURCES]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.UNITEDHEALTHCARE_ALL_SAVERS]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [InsuranceCompany.UPMC_COMMUNITY_HEALTHCHOICES]: {
    ccDestinationParent: CcDestinationParent.UPMC,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.UPMC_HEALTH_PLAN]: {
    ccDestinationParent: CcDestinationParent.UPMC,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.UPMC_WORKPARTNERS]: {
    ccDestinationParent: CcDestinationParent.UPMC,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.VETERANS_HEALTH_ADMINISTRATION]: {
    ccDestinationParent: CcDestinationParent.DEPARTMENT_OF_VETERANS_AFFAIRS,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.WELLCARE]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.WELLCARE_HEALTH_PLANS]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.WELLMARK_BLUE_CROSS_BLUE_SHIELD_OF_IOWA]: {
    ccDestinationParent: CcDestinationParent.WELLMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.WELLMARK,
  },
  [InsuranceCompany.WELLMARK_BLUE_CROSS_BLUE_SHIELD_OF_SOUTH_DAKOTA]: {
    ccDestinationParent: CcDestinationParent.WELLMARK,
    clinicalCriteriaParent: ClinicalCriteriaParent.WELLMARK,
  },
  [InsuranceCompany.WELLPOINT]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [InsuranceCompany.DEVOTED_HEALTH]: {
    ccDestinationParent: CcDestinationParent.DEVOTED_HEALTH,
  },
  // TODO
  [PBM.CAPITALRX]: {},
  [PBM.CARELONRX]: {
    ccDestinationParent: CcDestinationParent.ELEVANCE_HEALTH,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [PBM.CVS_CAREMARK]: {
    ccDestinationParent: CcDestinationParent.AETNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.AETNA,
  },
  // TODO
  [PBM.ELIXIR]: {},
  [PBM.ENVOLVE_PHARMACY_SOLUTIONS]: {
    ccDestinationParent: CcDestinationParent.CENTENE,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [PBM.EXPRESS_SCRIPTS]: {
    ccDestinationParent: CcDestinationParent.CIGNA,
    clinicalCriteriaParent: ClinicalCriteriaParent.CIGNA,
  },
  [PBM.HUMANA_PHARMACY_SOLUTIONS]: {
    ccDestinationParent: CcDestinationParent.HUMANA,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  [PBM.MAGELLAN_RX]: {
    ccDestinationParent: CcDestinationParent.PRIME,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  // TODO
  [PBM.MAGELLAN_RX_MANAGEMENT]: {},
  [PBM.MEDIMPACT]: {
    ccDestinationParent: CcDestinationParent.MEDIMPACT,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  // TODO
  [PBM.NAVITUS_HEALTH_SOLUTIONS]: {},
  [PBM.OPTUMRX]: {
    ccDestinationParent: CcDestinationParent.UNITEDHEALTHCARE,
    clinicalCriteriaParent: ClinicalCriteriaParent.UNITEDHEALTHCARE,
  },
  [PBM.PERFORMRX]: {
    ccDestinationParent: CcDestinationParent.INDEPENDENCE_BCBS,
    clinicalCriteriaParent: ClinicalCriteriaParent.BCBS,
  },
  [PBM.PRIME_THERAPEUTICS]: {
    ccDestinationParent: CcDestinationParent.PRIME,
    clinicalCriteriaParent: ClinicalCriteriaParent.ANTHEM,
  },
  // TODO
  [PBM.RIGHTWAY]: {},
  // TODO
  [PBM.RXADVANCE]: {},
  // TODO
  [PBM.WELLDYNERX]: {},
};
